import { combineReducers } from '@reduxjs/toolkit';

import abTestReducer from './abTests';
import accountSummaryReducer from './accountSummary';

// A reducer for model-like data that isn't keyed on some id
const sharedSummary = combineReducers({
    accountSummary: accountSummaryReducer,
    abTests: abTestReducer,
});

export default sharedSummary;
